import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, CardBody, Card, Container } from "reactstrap";

const options2 = [
    "Yes, that is correct.",
    "No, we turn over stock faster.",
    "No, we turn over stock slower.",
];

const options3 = [
    "Monthly. Regular cycle counts (every 1-3 months).",
    "Biannual. A full stock take is done twice a year.",
    "Annually. A full stock take is done once a year.",
    "Ad-hoc / As needed. Stock takes happen only when required (e.g., audits, loss prevention).",
    "We don't currently do this.",
];

const Step9 = () => {
    const [yesSelected2, setYesSelected2] = useState(null);

    // const [currentSelection, setCurrentSelection] = useState(1);
        const [currentSelection, setCurrentSelection] = useState("");
        const [currentSelection2, setCurrentSelection2] = useState("");

    // const updateSelection = (index) => {
    //     setCurrentSelection(index + 1);
    // };

    const [activeChoice, setActiveChoice] = useState(1);

    const changeChoice = (index) => {
        setActiveChoice(index + 1);
    };

    const containerStyle1 = {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'left',
        marginTop: '20px',
    };

    const sliderThumb2 = {
        position: 'absolute',
        width: '30px',
        height: '30px',
        backgroundColor: 'white',
        borderRadius: '50%',
        border: '2px solid #77bc4b',
        transition: 'top 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease',
        top: `${(currentSelection - 1) * 40}px`,
        boxShadow: currentSelection <= 4 ? 'rgb(255 87 51 / 50%) 0px 0px 10px' : 'none',
        transform: currentSelection <= 4 ? 'scale(1.1)' : 'scale(1)',
    };

    const sliderThumb3 = {
        position: 'absolute',
        width: '30px',
        height: '30px',
        backgroundColor: 'white',
        borderRadius: '50%',
        border: '2px solid #77bc4b',
        transition: 'top 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease',
        top: `${(activeChoice - 1) * 70}px`,
        boxShadow: activeChoice <= 4 ? 'rgb(51 102 255 / 50%) 0px 0px 10px' : 'none',
        transform: activeChoice <= 4 ? 'scale(1.1)' : 'scale(1)',
    };

    const numbersStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginRight: '10px',
    };

    const numberContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px',
    };

    const sliderStyle = {
        position: 'relative',
        width: '15px',
        height: '110px',
        backgroundColor: '#77bc4b',
        borderRadius: '35px',
        display: 'flex',
        justifyContent: 'center',
    };

    const sliderStyle3 = {
        position: 'relative',
        width: '15px',
        height: '300px',
        backgroundColor: '#77bc4b',
        borderRadius: '35px',
        display: 'flex',
        justifyContent: 'center',
    };

    const sliderBarStyle = {
        position: 'absolute',
        width: '10px',
        height: '350px',
        backgroundColor: 'transparent',
        borderRadius: '10px',
    };

    const optionsStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginLeft: '20px',
    };

    const optionStyle = (isActive) => ({
        fontSize: '14px',
        maxWidth: '250px',
        transition: 'color 0.3s ease, font-weight 0.3s ease',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        color: isActive ? 'black' : 'lightgray',
        fontWeight: isActive ? 'bold' : 'normal',
    });
    return (
        <React.Fragment>
           
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={8} xl={12}>
                            <Card className="overflow-hidden">
                                {/* <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20">About yourself</h5>
                    <p className="text-white-50">Let's get you onboard.</p>
                    <Link to="/index" className="logo logo-admin">
                      <img src={logoSm} height="24" alt="logo" />
                    </Link>
                  </div>
                </div> */}
                                <CardBody className="p-4">
                                    <div className="p-3">
                                        <div className="mb-4 p-3 bg-light">
                                            <h5 className="fw-bold">Looks like your business keeps stock on hand! Tell us a bit about your inventory.</h5>
                                        </div>
                                        <form className="mt-4" action="#">
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="industry">How much of your business’s needs does your major supplier provide?</label>
                                                {/* <div>
                                                    <div style={containerStyle1}>
                                                        <div style={numbersStyle}>
                                                            {options3.map((_, index) => (
                                                                <div key={index} style={numberContainerStyle}></div>
                                                            ))}
                                                        </div>
                                                        <div style={sliderStyle3}>
                                                            <div style={sliderBarStyle}></div>
                                                            <div style={sliderThumb3}></div>
                                                        </div>
                                                        <div style={optionsStyle}>
                                                            {options3.map((option, index) => (
                                                                <p key={index} style={optionStyle(activeChoice === index + 1)} onClick={() => changeChoice(index)}>
                                                                    {option}
                                                                </p>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div> */}

                                                <div className="d-flex gap-3 flex-wrap">
                                                    {options3.map((option, index) => (
                                                        <div
                                                            key={index}
                                                            style={{ width: "220px", height: "200px", fontSize: "16px" }}
                                                            className={`box flex items-center justify-center p-4 w-40 h-20 rounded-lg cursor-pointer ${currentSelection2 === option
                                                                ? "selected bg-[#A3E566] text-blue"
                                                                : "bg-gray-100 text-black"
                                                                }`}
                                                            onClick={() => setCurrentSelection2(option)}
                                                        >
                                                            {option}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">Does the stock level on your balance sheet accurately reflect what you actually have on hand?</label>
                                                <div className="d-flex">
                                                    <button
                                                        type="button"
                                                        className="btn ms-2"
                                                        style={{ backgroundColor: yesSelected2 === true ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: yesSelected2 === true ? "white" : "#77bc4b" }}
                                                        onClick={() => setYesSelected2(true)}
                                                    >
                                                        YES
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn ms-2"
                                                        style={{ backgroundColor: yesSelected2 === false ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: yesSelected2 === false ? "white" : "#77bc4b" }}
                                                        onClick={() => setYesSelected2(false)}
                                                    >
                                                        NO
                                                    </button>
                                                </div>
                                            </div>
                                            
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="industry">Based on your financial statements, it looks like you turn over your stock every X days. Does that sound about right?</label>
                                                {/* <div>
                                                    <div style={containerStyle1}>
                                                        <div style={numbersStyle}>
                                                            {options2.map((_, index) => (
                                                                <div key={index} style={numberContainerStyle}></div>
                                                            ))}
                                                        </div>
                                                        <div style={sliderStyle}>
                                                            <div style={sliderBarStyle}></div>
                                                            <div style={sliderThumb2}></div>
                                                        </div>
                                                        <div style={optionsStyle}>
                                                            {options2.map((option, index) => (
                                                                <p key={index} style={optionStyle(currentSelection === index + 1)} onClick={() => updateSelection(index)}>
                                                                    {option}
                                                                </p>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div> */}

                                                <div className="d-flex gap-3 flex-wrap">
                                                    {options2.map((option, index) => (
                                                        <div
                                                            key={index}
                                                             style={{width:"220px", height: "200px"}}
                                                            className={`box flex items-center justify-center p-4 w-40 h-20 rounded-lg cursor-pointer ${currentSelection === option
                                                                    ? "selected bg-[#A3E566] text-blue"
                                                                    : "bg-gray-100 text-black"
                                                                }`}
                                                            onClick={() => setCurrentSelection(option)}
                                                        >
                                                            {option}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Step9;
